import { AbstractControl, ValidationErrors } from '@angular/forms'

export function passwordValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value || ''

  const errors: any = {}
  if (value.length < 8) {
    errors.minLength = true
  }
  if (!/[a-z]/.test(value)) {
    errors.missingLowercase = true
  }
  if (!/[A-Z]/.test(value)) {
    errors.missingUppercase = true
  }
  if (!/[0-9]/.test(value)) {
    errors.missingNumber = true
  }

  return Object.keys(errors).length ? errors : null
}